import React, { useState } from "react";

export default function TextFrom(props) {

    const handleUpperClick = () => {
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to UPPERCASE!", "success");
    };
    const handleLowerClick = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to lowercase!", "success");
    };
    const handleSentenceClick = () => {
        let newText = text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
        setText(newText);
        props.showAlert("Converted to Sentence case!", "success");
    };

    const handleAlternateClick = () =>{
        let newText = text.toUpperCase().split("");
        for (let i = 0; i < newText.length; i += 2) {
            newText[i] = newText[i].toLocaleLowerCase();
        }
        setText(newText.join(""));
        props.showAlert("Converted to Alternate Case!", "success");
    };

    const handleClearClick = () => {
        let newText = "";
        setText(newText);
        props.showAlert("Text cleared!", "success");
        
    };
    
    const handleCopyClick = () => {
        navigator.clipboard.writeText(text);
        props.showAlert("Copied to clipboard!", "success");
    };

    const handleExtraSpaces = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
        props.showAlert("Extra spaces removed!", "success");
    };

    const handleOnChange = (event) => {
        setText(event.target.value);
    };
    const [text, setText] = useState("");


    return (
        <>
            <div className="container"  style={
                { color: props.mode === "dark" ? "white" : "black" }
            } >
                <h3>Accidentally left the caps lock on and typed something, but can't be bothered to start again and retype it all?</h3>
                <div className="mb-3">
                    <p>Simply enter your text and choose the case you want to convert it to.</p>
                    <textarea className="form-control" value={text} onChange= {handleOnChange} style={{
                            backgroundColor: props.mode === "dark" ? "black" : "white",
                            color: props.mode === "dark" ? "white" : "black",
                        }} id="myBox" rows="8" placeholder="Enter your text"
                    ></textarea>
                </div>
                <button disabled={text.length===0} className="btn btn-success mx-1 my-1 btn-sm" onClick={handleUpperClick}> UPPER CASE </button>
                <button disabled={text.length===0} className="btn btn-success mx-1 my-1 btn-sm" onClick={handleLowerClick}>  lower case </button>
                <button disabled={text.length===0} className="btn btn-success mx-1 my-1 btn-sm" onClick={handleSentenceClick}> Sentence case </button>
                <button disabled={text.length===0} className="btn btn-success mx-1 my-1 btn-sm" onClick={handleAlternateClick}> AlTeRnAtE cAsE </button>
                <button disabled={text.length===0} className="btn btn-warning mx-1 my-1 btn-sm" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
                <button disabled={text.length===0} className="btn btn-secondary mx-1 my-1 btn-sm" onClick={handleCopyClick}> Copy Text </button>
                <button disabled={text.length===0} className="btn btn-danger mx-1 my-1 btn-sm" onClick={handleClearClick}> Clear Text </button>
            </div>


            <div className="container my-3" style={{ color: props.mode === "dark" ? "white" : "black" }} >
                <p> Word count : {text.split(/\s+/).filter((element)=>{return element.length!==0}).length} | Character Count :  {text.length} | It will take {0.30 * text.split(" ").filter((element)=>{return element.length!==0}).length} seconds to read. </p>
                <h6>{text.length > 0 ? text : "Nothing to preview!"}</h6>
            </div>
        </>
    );
}
